import { atom } from 'jotai';

// FORMS SUBMIT ATOM

export const formsSubmitAtom = atom(false);

// GO BACK ATOM

export const goBackAtom = atom({ 
    goBack: false,
    goBackRoute: ''
});